export default "__VITE_ASSET__CXk7GsBC__"